import React from "react";

import Card from "@material-ui/core/Card";
import { Grid } from "@material-ui/core";
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SearchIcon from '@mui/icons-material/Search';
import { formatDateDDMMYYYYHHMM } from "../../../plas/utils";

function ErrorItem({ error, onOpen }) {

  return (
    <Grid container>
      <Grid item xs={12}>
        <Card elevation={1} style={{padding: 8}} >
          <Grid container>
            <Grid item xs={"wrap"} style={{marginLeft: 10}}>
              <Grid container>
                <Grid item xs={"wrap"}>
                  <span style={{fontSize: 14, color: 'gray'}}>{ `#${error.id} - ${formatDateDDMMYYYYHHMM(error.time)}` }</span>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={"wrap"}>
                  <span style={{fontSize: 17 }}>{error.service}</span>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={true} style={{marginRight: 10}}>
              <Grid container>
                <Grid item xs={12} style={{textAlign: 'end'}}>
                  { error.userId ? (
                    <span style={{fontSize: 14, color: 'gray'}}>{ `Usuario ${error.userId}` }</span>
                  ):(
                    <span style={{fontSize: 14, color: 'gray'}}>Operación automática</span>
                  )}
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} style={{textAlign: 'end'}}>
                  <span style={{fontSize: 17}}>{ error.operation }</span>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={"wrap"}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100%"> 
                <Tooltip title="Ver detalles">
                  <span>
                    <IconButton onClick={() => onOpen(error)}>
                      <SearchIcon fontSize="big"/>
                    </IconButton>
                  </span>
                </Tooltip>
              </Box>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );

}

export default ErrorItem;
